/**
 * Handle recaptchas
 */
class RecaptchaWidget {
    /**
     * @param {Object} pGrecaptcha grecaptcha object.
     * @param {Array.<HTMLInputElement>} pRecaptchaCollection array of widget recaptcha inputs.
     * @param {String} pGeneralMessage error message.
     * @param {GRECAPTCHA_OPTIONS} pOptions GrecaptchaV2_JS options.
     * @param {Function} pOnSubmit submit form event callback
     */
    constructor(pGrecaptcha, pRecaptchaCollection, pGeneralMessage, pOptions, pOnSubmit = null) {
        if (!pGrecaptcha) {
            throw new Error('Missing grecaptcha object.');
        }
        /**
         * Flag to signal has recaptcha token value.
         * @type {Boolean} 
         */
        this.HasValue = false;
        /**
         * General Error message.
         * @type {String}
         */
        this.ErrorMessage = pGeneralMessage;
        /**
         * submit event callback
         * @type {Function}
         */
        this.OnSubmit = pOnSubmit;
        /**
         * several recaptchas in a form.
         * @type {Array.<recaptcha_collection>}
         */
        this.RecaptchaCollection = (!!pRecaptchaCollection && pRecaptchaCollection.length > 0) &&
            (
                pRecaptchaCollection = [].slice.call(pRecaptchaCollection, 0)
                ,
                pRecaptchaCollection.map(r => {
                    // Load widget params
                    let widgetParams = !!r.dataset.widgetParam ? JSON.parse(r.dataset.widgetParam) : {},
                        defaultOptions = {
                            version: "2.0",
                            message: "Valida el recaptcha para continuar.",
                            target: r.dataset.widgetTarget,
                            inputForm: r
                        };
                    Object.assign(defaultOptions, widgetParams);
                    return defaultOptions;
                })
            );

        /**
         * result after form validation 
         * response comes from Form_JS
         * @type {VALIDATION_RESPONSE}
         */
        this._formValidationResponse = null;
        this.init(pOptions, pGrecaptcha, pOnSubmit);
    }
    /**
     * Load serveral recaptchas belonged to the same siteKey.
     * @param {GRECAPTCHA_OPTIONS} pOptions 
     * @param {Object} pGrecaptcha grecaptcha object.
     */
    init(pOptions, pGrecaptcha) {
        if (!this.RecaptchaCollection) {
            throw new Error('RecaptchaWidget: Missing input recaptcha collection.');
        }

        this.RecaptchaCollection.forEach(or => {
            let options = {
                selector: or.target,
                inputForm: or.inputForm,
                callback: this.getCaptchaResponse(),
                expiredCallback: this.expiredWidgetRecaptcha(),
                ...pOptions
            };
            Object.assign(options, pOptions)
            if (or.version === "2.0") {
                or.grecaptchaV2 = new GrecaptchaV2_JS(pGrecaptcha, options);
            }
        });
    }
    /**
     * Reset all Recaptcha.
     */
    reset() {
        this.RecaptchaCollection.forEach(or => or.grecaptchaV2.reset());
    }
    /**
     * Set a function to reset all recaptcha except  checked recaptcha.
     * @returns {Function} reset all recaptcha except  checked recaptcha fuction.
     */
    getCaptchaResponse() {
        const objThis = this;
        return (token) => {

            if (!token) {
                return;
            }

            let arrayCheckedRecaptcha = objThis.RecaptchaCollection.filter(or => !or.grecaptchaV2.IsInvisible && or.grecaptchaV2.CaptchaToken.length > 0),
                isCheckBoxResponse = false
            const _hasInvisibleCaptcha = objThis.RecaptchaCollection.some(or => or.grecaptchaV2.IsInvisible);
            ;
            arrayCheckedRecaptcha.forEach(or => {
                if (token == or.grecaptchaV2.CaptchaToken) {
                    isCheckBoxResponse = true;
                }
                else {
                    or.grecaptchaV2.reset();
                }
            });

            objThis.HasValue = true;

            if (_hasInvisibleCaptcha && !isCheckBoxResponse) {
                (typeof this.OnSubmit === 'function') && this.OnSubmit(token, this._formValidationResponse);
            }
        }
    }
    /**
     * Set a function to set HasValue flag to true.
     * @returns {Function} function to set HasValue flag to true.
     */
    expiredWidgetRecaptcha() {
        const objThis = this;
        return () => {
            let arrayCheckedRecaptcha = objThis.RecaptchaCollection.filter(or => or.grecaptchaV2.getResponse().length > 0);
            if (!!arrayCheckedRecaptcha && arrayCheckedRecaptcha.length > 0) {
                objThis.HasValue = true;
            } else {
                objThis.HasValue = false;
            }
        }
    }
    /**
     * get Recaptcha value
     * @param {VALIDATION_RESPONSE} formValidationResponse validation form result
     */
    getResponse(formValidationResponse) {

        let tokenValue = '';
        const _invisibleCaptcha = this.RecaptchaCollection.filter(or => or.grecaptchaV2.IsInvisible).at(0)
            ;

        if (_invisibleCaptcha) {
            this._formValidationResponse = formValidationResponse;
            _invisibleCaptcha.grecaptchaV2.getResponse();
            return;
        }

        this.RecaptchaCollection
            .filter(or => !or.grecaptchaV2.IsInvisible)
            .some(or => {
                if (or.grecaptchaV2.hasResponse()) {
                    tokenValue = or.grecaptchaV2.CaptchaToken;
                    return true;
                }
                return false;
            });

        (typeof this.OnSubmit === 'function' && this.OnSubmit(tokenValue, formValidationResponse));
    }
}